import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-t-small', 'LetterTSmall', [["path",{"d":"M10 8h4","key":"svg-0"}],["path",{"d":"M12 8v8","key":"svg-1"}]]);